var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames", "../../UI/Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"), require("../../UI/Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Icon);
    global.ProgramBreadcrumb = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames, _Icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _Icon = _interopRequireDefault(_Icon);

  var ProgramBreadcrumb = function ProgramBreadcrumb(_ref) {
    var className = _ref.className,
        links = _ref.links,
        separator = _ref.separator,
        breadcrumbLabel = _ref.breadcrumbLabel,
        titleLevel = _ref.titleLevel;
    var countLinks = links.length;
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: (0, _classnames.default)('program-breadcrumb', className),
      "aria-label": breadcrumbLabel
    }, links.map(function (_ref2, index) {
      var color = _ref2.color,
          label = _ref2.label,
          url = _ref2.url;
      var isLast = index + 1 === countLinks;
      var component = url ? /*#__PURE__*/_react.default.createElement("a", {
        className: (0, _classnames.default)('program-breadcrumb__link', [color ? "next-color--".concat(color, " program-breadcrumb__category") : 'next-color--isWhite']),
        href: url
      }, label) : /*#__PURE__*/_react.default.createElement("span", {
        className: "program-breadcrumb__label"
      }, label);
      return /*#__PURE__*/_react.default.createElement(titleLevel && isLast ? "h".concat(titleLevel) : 'div', titleLevel && isLast ? {
        key: "program-breadcrumb-".concat(index),
        className: 'program-breadcrumb__title'
      } : {
        key: "program-breadcrumb-".concat(index)
      }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, component, separator && !isLast && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: "program-breadcrumb__separator",
        name: separator,
        size: "xxsmall"
      })));
    }));
  };

  ProgramBreadcrumb.propTypes = {
    breadcrumbLabel: _propTypes.default.string.isRequired,
    className: _propTypes.default.string,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      color: _propTypes.default.string,
      label: _propTypes.default.string.isRequired,
      url: _propTypes.default.string
    })).isRequired,
    separator: _propTypes.default.string,
    titleLevel: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6])
  };
  ProgramBreadcrumb.defaultProps = {
    className: '',
    links: [],
    separator: ''
  };
  var _default = ProgramBreadcrumb;
  _exports.default = _default;
});